import { Component, HostBinding, Input } from "@angular/core";

export type BadgeVariant = "default" | "secondary" | "destructive" | "outline" | "count";

@Component({
    selector: "app-badge",
    templateUrl: "./badge.component.html",
    styleUrl: "./badge.component.scss",
    standalone: false,
})
export class BadgeComponent {
    @Input() variant: BadgeVariant = "default";
    @Input() class: string = "";

    @HostBinding("class.count")
    get isCountVariant() {
        return this.variant === "count";
    }

    getBadgeClasses(): string {
        const baseClasses = "badge";
        const variantClass = this.getVariantClass();
        const customClasses = this.class;

        return [baseClasses, variantClass, customClasses].filter(Boolean).join(" ");
    }

    private getVariantClass(): string {
        switch (this.variant) {
            case "secondary":
                return "badge-secondary";
            case "destructive":
                return "badge-destructive";
            case "outline":
                return "badge-outline";
            case "count":
                return "badge-count";
            default:
                return "badge-default";
        }
    }
}
